import { TestIdDomain } from 'constants/testIds';

export const ClickablePhoneTestIds = {
  CALL_BUTTON: `${TestIdDomain.COMMON}.clickable-phone-button`,
  VALUE_LABEL: `${TestIdDomain.COMMON}.clickable-phone-label`,
};
